import React from "react";

interface NoWarehousesMessageProps {
  className?: string;
  style?: React.CSSProperties;
}

const NoWarehousesMessage: React.FC<NoWarehousesMessageProps> = ({
  className = "text-center py-5",
  style
}) => {
  return (
    <div className={className} style={style}>
      <p className="text-muted">
        No warehouses are configured for your account. Please contact your administrator to configure warehouses.
      </p>
    </div>
  );
};

export default NoWarehousesMessage;